import HttpService from "./htttp.service";

class RoleService {
  endpoint = 'roles';

  getAll = async (payload = null) => {
    return await HttpService.get(`${this.endpoint}/`, payload);
  };

  get = async (id) => {
    return await HttpService.get(`${this.endpoint}/${id}`);
  };

  getpermissions = async () => {
    return await HttpService.get('/permissions/permissions');
  };

  create = async (payload) => {
    return await HttpService.post(`${this.endpoint}/create`, payload);
  };

  update = async (id, payload) => {
    return await HttpService.put(`${this.endpoint}/${id}`, payload);
  }

  delete = async (id) => {
    return await HttpService.delete(`${this.endpoint}/${id}`);
  }
}

export default new RoleService();
